export const goalOptions = [
    'Building wealth/investment portfolio',
    'Shareholder advocacy',
    'Diversifying my investments',
    'Saving for a home',
    'Saving for emergency funds',
    'Preparing for retirement',
    'Financial independence',
]
